import { listingTutosMock, titreDescriptionMock, titreTexteCtaImageMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMock(), listingTutosMock, titreTexteCtaImageMock('gray', false, false, true)];

export const tutosMock: SlugPage = {
  ...pageBase({
    title: 'Tutos',
    type: 'tutos',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
